import { requestHistoryBasedSimilarOffers } from './requestHistoryBasedSimilarOffers';
import { requestItemBasedSimilarOffers } from './requestItemBasedSimilarOffers';
import { requestNewItemBasedSimilarOffers } from './requestNewItemBasedSimilarOffers';
import { requestUserBasedSimilarOffers } from './requestUserBasedSimilarOffers';
import { TModelType } from '../types';

interface IRequestSimilarOffersParams {
  offerId: number;
  publishedUserId: number | null;
  modelType: TModelType;
}

export function requestSimilarOffers(params: IRequestSimilarOffersParams) {
  const { offerId, publishedUserId, modelType } = params;

  switch (modelType) {
    case 'userBased':
      return requestUserBasedSimilarOffers(offerId, publishedUserId);

    case 'itemBased':
      return requestItemBasedSimilarOffers(offerId, publishedUserId);

    case 'newItemBased':
      return requestNewItemBasedSimilarOffers(offerId, publishedUserId);

    case 'historyBased':
      return requestHistoryBasedSimilarOffers();
  }
}
